// Messages the checkout forms show next to the Pay button
export const TERMS_HINT = "Please tick to agree to the Terms and Conditions";
export const PAYMENT_FAILED =
  "That payment didn't go through. Please try again or use a different card.";
export const PAYMENT_PENDING =
  "Your payment hasn't been confirmed yet. Check its status before trying another payment.";
export const CHECKOUT_NOT_READY =
  "We couldn't get your checkout ready. Please try again.";
// The checkout refuses (409 already_purchased) to sell a plan the buyer holds
export const ALREADY_PURCHASED =
  "You already have this plan. Updating your access now.";
export const isAlreadyPurchased = (response, data) =>
  response?.status === 409 && data?.code === "already_purchased";

// What to show for an error from stripe.confirmPayment. Card and validation
// errors carry Stripe's own buyer-facing message (a decline, an incomplete
// card, failed authentication); anything else is an integration problem the
// buyer can't fix, so they get the general message.
export const describePaymentError = (error) => {
  if ([error?.code, error?.decline_code].includes("incorrect_cvc") ||
      [error?.code, error?.decline_code].includes("invalid_cvc")) {
    return "Your card's security code (CVC/CVV) is incorrect. Please check it and try again.";
  }
  if (error?.type === "card_error" || error?.type === "validation_error") {
    return error.message || PAYMENT_FAILED;
  }
  return PAYMENT_FAILED;
};
